import {Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {AssetModel} from '../_models/asset.model';
import {IM_DF_CUM_SUFFIX, IM_DF_OC_SUFFIX, IM_DF_PNL_SUFFIX, PlantRiskModel} from '../_models/plant-risk.model';
import {PlantRiskService} from '../_services/plant-risk.service';
import {Subject, timer} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {SwiperConfigInterface} from 'ngx-swiper-wrapper';
import {FuncsService} from '../../shared/_services/funcs.service';

@Component({
  selector: 'app-outage',
  templateUrl: './outage.component.html',
  styleUrls: ['./outage.component.scss']
})

export class OutageComponent implements OnInit, OnChanges, OnDestroy {

  @Input() country: AssetModel;
  @Input() withTable: boolean;

  @ViewChild('swiper') swiperInst: ElementRef;

  oc: PlantRiskModel[];
  ocMerged: any[];
  vsItems: any[];

  swiperConfig: SwiperConfigInterface = {
    noSwiping: true,
    noSwipingClass: 'slide-noswiping',
    observer: true,
    spaceBetween: 40,
    speed: 400,
  };
  swiperIdx = 0;

  // FOR HTML
  OC_SUFFIX = IM_DF_OC_SUFFIX;
  PNL_SUFFIX = IM_DF_PNL_SUFFIX;
  CUM_SUFFIX = IM_DF_CUM_SUFFIX;
  HAS_DATA = 'hasData';

  private onDestroy$: Subject<void> = new Subject<void>();

  constructor(
    private plantRiskService: PlantRiskService,
  ) {
  }

  ngOnInit() {
    this.getPlantRisk();
    this.getPlantRiskOutage();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('withTable')) {
      this.updateSwiper();
    }
  }

  ngOnDestroy() {
    this.onDestroy$.next();
  }

  // ********************************************************************************************************
  // LOAD DATA
  // ********************************************************************************************************

  private getPlantRisk(): void {
    this.plantRiskService.onNewPlantRisk()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (pr) => {
          this.oc = [];
          if (pr.length) {
            this.oc = pr.filter((i) => i.country === this.country.label) || [];
          }
        }
      );
  }

  private getPlantRiskOutage(): void {
    this.plantRiskService.onNewPlantRiskOutage()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (pr) => {
          this.ocMerged = [];
          if (pr.length) {
            const prCountry = pr.find((i) => i.country === this.country.label);
            if (prCountry) {
              this.ocMerged = FuncsService.copy(prCountry.outageData);
              this.cleanOcMerged();
            }
          }
        }
      );
  }

  private cleanOcMerged(): void {
    // replace NaNs and remove empty lines
    for (let i = 0; i < this.ocMerged.length; i++) {
      // TODO: find better way then another loop ?
      this.ocMerged[i][this.HAS_DATA] = false;
      for (const key in this.ocMerged[i]) {
        if (this.ocMerged[i].hasOwnProperty(key) && key !== 'ts' && key !== 'hasData' && !key.includes(IM_DF_CUM_SUFFIX)) {
          this.ocMerged[i][key] = this.ocMerged[i][key] === null || Number.isNaN(this.ocMerged[i][key]) ? 0 : this.ocMerged[i][key];
          this.ocMerged[i][this.HAS_DATA] = this.ocMerged[i][this.HAS_DATA] || !!this.ocMerged[i][key];
          const dType = key.slice(-IM_DF_OC_SUFFIX.length);
          const cumKey = key.replace(dType, dType + IM_DF_CUM_SUFFIX);
          this.ocMerged[i][cumKey] = i === 0 ? this.ocMerged[i][key] : this.ocMerged[i - 1][cumKey] + this.ocMerged[i][key];
        }
      }
    }
  }

  // ********************************************************************************************************
  // PROCESS DATA
  // ********************************************************************************************************

  // ********************************************************************************************************
  // UI
  // ********************************************************************************************************

  onSwipe(idx: number): void {
    this.swiperIdx = idx;
  }

  private updateSwiper(): void {
    if (this.swiperInst) {
      timer(4).subscribe(() => {
        this.swiperInst.nativeElement.swiper.update();
      });
    }
  }

}
